<template>
  <base-legal-page
    kicker="Dad Jokes Vault"
    title="Dad Jokes Vault - Support"
  >
    <p>We're here to help you get the most out of Dad Jokes Vault.</p>

    <h2>About Dad Jokes Vault</h2>
    <p>
      Dad Jokes Vault is a feed of dad jokes: one joke per page, tap the card to reveal the punchline, swipe for the next one. Save your favorites, browse by category, and hear some jokes read aloud in two voices, Dad and Kid.
    </p>

    <h2>Frequently Asked Questions</h2>

    <p><strong>Why is the punchline hidden?</strong></p>
    <p>
      The punchline is hidden on purpose — tap the card to reveal it. That's the joke.
    </p>

    <p><strong>Why does Read aloud only appear on some jokes?</strong></p>
    <p>
      Read aloud shows up only on jokes that already have a recorded clip in the two voices, Dad and Kid. We're recording more jokes over time, so it will show up on more of them with future updates.
    </p>

    <p><strong>Does it work offline?</strong></p>
    <p>
      Yes, for reading. The joke library ships inside the app, so you can browse, reveal punchlines, and bookmark jokes with no connection. Read aloud clips are downloaded the first time you play them and then stay cached on your phone, so an internet connection is only needed the first time you hear a given joke.
    </p>

    <p><strong>What does the purchase include?</strong></p>
    <p>
      One purchase unlocks the entire library permanently, including categories added later. There is no subscription and nothing recurring.
    </p>

    <p><strong>I bought it before and reinstalled. How do I get it back?</strong></p>
    <p>
      Open About from the feed and tap "Restore." Apple will confirm the purchase on your account and the library will unlock again. Make sure you are signed in with the same Apple Account you bought it with.
    </p>

    <p><strong>Is my progress saved anywhere?</strong></p>
    <p>
      Your bookmarks, reading history, and settings are stored on your device only. They are never uploaded, which also means they are not carried across to a new device and are removed if you delete the app.
    </p>

    <p><strong>How do I turn sound effects on or off?</strong></p>
    <p>
      Open About from the feed — there's a toggle for sound effects there.
    </p>

    <p><strong>The app is crashing or not working properly. What should I do?</strong></p>
    <p>Please try the following steps:</p>
    <ul>
      <li>Make sure you have the latest version of the app installed</li>
      <li>Restart the app</li>
      <li>Restart your device</li>
    </ul>
    <p>
      If the issue persists, contact us below and include your device model, your iOS version, and the version and build number shown on the About screen.
    </p>

    <h2>Contact Us</h2>
    <p>
      If you need further assistance or have any questions, feedback, or concerns, please reach out to us:
    </p>
    <div class="hh-legal__contact">
      <div><strong>Email:</strong> <a href="mailto:info@hackerhang.com">info@hackerhang.com</a></div>
      <div><strong>Website:</strong> <a href="https://hackerhang.com">hackerhang.com</a></div>
    </div>
  </base-legal-page>
</template>

<script>
  export default {
    name: 'DadjokesSupport',

    metaInfo: { title: 'Dad Jokes Vault Support' },
  }
</script>
